import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'amfe-flexible/index.js'
//弹框拖拽
import './utils/directive'
//引入字体
import '@/assets/font/font.css'
//引入element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../public/element'
// axios
import axios from '@/utils/requets.js';
import VueAxios from 'vue-axios';
Vue.use(VueAxios, axios);
Vue.use(ElementUI);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
